import * as types from '../constants/commonConstants';
import config from '../config';

// Auth
export function isLoaded(globalState) {
  return globalState.auth && globalState.auth.loaded;
}

export function showLoadingIndicator() {
  return {
    type: types.LOADING_ON
  };
}

export function stopLoadingIndicator() {
  return {
    type: types.LOADING_OFF
  };
}

// Handle popup
export function handleModal(status) {
  return {
    type: types.HANDLE_MODAL,
    status
  };
}
export function closeforcedModal(){
  return{
    type:types.CL_FORCED_LOGOUT
  }
}


// Hide the dialog
export function hideDialog() {
  return {
    type: types.HIDE_DIALOG,
  };
}

// To toggle between trade and report
export function navigationTradeReport(option) {
  return {
    type: types.NAVIGATE_TRADE_REPORT,
    option
  };
}

//Handle popouts
export function popupwindowHandle(open, key) {
  return {
    type: types.POPUP_WINDOW_HANDLE,
    opened: open,
    key
  };
}
// Handle popouts
export function popinWidget(key) {
  return {
    type: types.POPUPCLOSE_HANDLE,
    key
  };
}
export function changeLanguage(lang) {
  return {
    type: types.LOAD_LANG,
    lang
  };
}
export function setSessionKillFlag(key){
  var msg="";
  return {
    type: types.KILL_SESSION,
    key,msg
  };
}
export function loadLockFlag(flag){
  return {
    type: types.LOAD_LOCK_FLAG,
     flag
   };
}
export function openModal(setFlag){
  return {
    type: types.LOCK_UNLOCK_FLAG,
     setFlag
   };
}
export function unlockSuccess(successFlag){
  return {
    type: types.UNLOCK_PSD_SUCCESS,
     successFlag
   };
}
export function unlockVerify(password){
  return {
    type: types.UNLOCK_VERIFY,
    promise: (client) => client.post('/unlockVerify', {
      data: {
      password:password
    }})
  };
}
export function resetUnlockState(){
  return {
    type: types.RESET_UNLOCK
   };
}
export function getAllColors(){
  return {
    type: types.GET_ALL_COLORS,
    promise: (client) => client.get('/getThemesList?theme_for=trd')
  };
}

export function setTheme(selectedCssColor){
  return {
    type:types.CHANGE_THEME,
    selectedCssColor
  }
}

export function setSelectedCssTheme(selectedCssColorTheme){
  return{
    type:types.SELECTED_CSS_THEME,
    selectedCssColorTheme
  }
}
export function setSelectedLangJson(selectedLang){
  return{
    type:types.SELECTED_LANG,
    selectedLang
  }
}
export function isProfileClicked(isprofileFlag){
  return{
    type:types.IS_PROFILE_CLIKED,
    isprofileFlag
  }
}

export function setUnlockModal(unlockScreenFlag) {
  return {
    type: types.UNLOCK_MODAL_STATUS,
    unlockScreenFlag
  };
}
export function checkLockStatus(checkLockFlag) {
  return {
    type: types.UNLOCK_CHANGE_STATUS,
    checkLockFlag
  };
}
export function onClickCalender(flag,keyValue){
  return{
    type:types.CHANGE_CALENDAR_FLAG,
    flag,keyValue
  }
}

export function resetThresholdState(){
  return{
  type: types.RESET_THRESHOLDSTATE,
  }
 }

export function getPath(path){
var port=window.location.port!==0||window.location.port!==""?":"+window.location.port:null;
  if(path==="api"){
    return window.location.hostname==="localhost"?config.apiPath:window.location.origin+"/api"
  }else if(path==="rate"){
    return window.location.hostname==="localhost"?config.wsRatePath:window.location.protocol==="https:"?"wss://"+window.location.hostname+port+"/ws":"ws://"+window.location.hostname+port+"/ws";
  }else{
    return window.location.hostname==="localhost"?config.wsOrderPath:window.location.protocol==="https:"?"wss://"+window.location.hostname+port+"/ws":"ws://"+window.location.hostname+port+"/ws";
  }
}

export function loadStkWisePairList() {
  return {
    type: types.LOAD_STKWISEPAIR,
    promise: (client) => client.get('/getStkTypeWisePair', {})
  };
}

export function validateOrder(orderDetails) {
  // console.log("data " + JSON.stringify(orderDetails));  
  return {
    type: types.VALIDATE_ORD_API,
    promise: (client) => client.post('/validateOrder', {data:{orderDetails}})
  };
}

export function sendErrorLogs(err) {
  const user = JSON.parse(localStorage.getItem('userDetail'));
  const platform = localStorage.getItem('platform');
  const location = localStorage.getItem('location');
  const data = {
          app: "Trader",
          userDetails: { SID: user.SID, UDES: user.UD, UID: user.UID, Platform: platform},
          errDetails: err,
          location: location,
          time: new Date()
          }
  return {
    type: types.SEND_LOG,
    promise: (client) => client.post('/getAllLogsData', {data:{data}})
    // dispatch(CommonActions.handleAPICall(data, '/getAllLogsData', 'SEND_LOG', 'POST'));
  };
}

export function logFileCreation(errorObj) {
  return {
    type: types.LOG_FILE_CREATE,
    errorObj
  }
}


export function loadDeliveries({ type, from, to }) {

  const user = JSON.parse(localStorage.getItem('user'));
  const UID = user.UID;
  const CID = user.location;

  let url = `/loadAllPhysicalDeliveries?&isTrader=true&type=${type}`;

  if (type === 'C') {
    url += `&from=${from}&to=${to}`;
  }

  return {
    type: types.LOAD_DELIVERIES,
    promise: (client) => client.get(url)
  };
}

export function getMarginForPD(){
  return {
    type: types.GET_MARGIN_FOR_PD,
    promise: (client) => client.get(`/getMarginForPd?accCode=${JSON.parse(localStorage.getItem("DFA")).C}&UT=${"trader"}&isOrders=${true}`)
  }
}

export function getPremiumDetails() {
  const user = JSON.parse(localStorage.getItem('user'));
  const AC = user.UID;
  const CID = user.location;

  return {
    type: types.GET_PREMIUM_DETAILS,
    promise: (client) => client.post(`/premiumDetails/premiumMaster`)
  }
}


export function getLocations() {
  const user = JSON.parse(localStorage.getItem('user'));
  const AC = user.UID;
  const CID = user.location;
  return {
    type: types.GET_LOCATION_DETAILS,
    promise: (client) => client.get(`/location?cid=${CID}&ac=${AC}`)
  };
}

export function placeRequest(placeRequestPayload) {
  return {
    type: types.PLACE_REQUEST,
    payload: placeRequestPayload,
    promise: (client) => client.post('/placeDelivery', {data:{...placeRequestPayload}})
  };
}

export function hidePlaceModal(){
  return {
    type: types.HIDE_PLACE_REQUEST_SUCCESS_MODAL
  };
}

export function cancelDeliveryRequest(cancelDeliveryPayload) {
  return {
    type: types.CANCEL_DELIVERY_REQUEST,
    promise: (client) => client.post('/cancelDeliveryRequest', {data:{...cancelDeliveryPayload}})
  };
}